import React, { FC } from 'react';

import { styled } from '@mui/material';
import { Maybe } from 'graphql/jsutils/Maybe';

import CircleCheckIcon from '~/assets/icons/CircleCheckIcon';
import { BodyText } from '~/components/UI/Texts';
import { SMALL_MARGIN_PX } from '~/theme';

interface PlanFeaturesProps {
  title: string;
  features: Maybe<string>[];
}

const PlanFeatures: FC<PlanFeaturesProps> = ({ title, features }) => {
  return (
    <div>
      <StyledBodyText>{title}</StyledBodyText>
      <StyledFeaturesList>
        {features.map((feature, index) => (
          <StyledFeature key={index}>
            <StyledCheckIcon />
            <StyledFeatureItem>{feature}</StyledFeatureItem>
          </StyledFeature>
        ))}
      </StyledFeaturesList>
    </div>
  );
};

export default PlanFeatures;

// TODO: adjust BodyText component to accept color prop
const StyledBodyText = styled(BodyText)`
  color: ${({ theme }) => theme.palette.common.white};
`;
const StyledFeaturesList = styled('ul')`
  margin-top: ${SMALL_MARGIN_PX};
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  padding-left: 0;
`;
const StyledFeature = styled('li')`
  display: flex;
  align-items: center;
  margin-bottom: ${SMALL_MARGIN_PX};
  font-size: 16px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 18px;
  }
`;
const StyledCheckIcon = styled(CircleCheckIcon)`
  min-width: 24px;
  margin-right: ${SMALL_MARGIN_PX};
  width: 24px;
  height: 24px;
`;
const StyledFeatureItem = styled('span')`
  white-space: pre-wrap;
`;
